<template>
  <div class="ageData-index">
    <div class="marketing-search">
      <el-row :class="`form-row`" :gutter="0">
        <div class="col-left">
          <el-form ref="form" :model="form" label-width="100px">
            <el-row :gutter="16" class="form-item-row">
              <el-col :span="8" v-if="form.type=='month'">
                <el-form-item label="月份" prop="monthList">
                  <el-date-picker
                    key="monthList"
                    type="months"
                    format="yyyy-MM"
                    v-model="form.monthList"
                    placeholder="请选择月份">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8"  v-if="form.type=='month'&&form.monthList&&form.monthList.length!=0">
                <el-form-item label="日期" prop="datesTime">
                  <el-date-picker
                    popper-class="due_dates"
                    key="dayList"
                    type="dates"
                    format="dd"
                    v-model="form.dayList"
                    placeholder="请选择日期"
                     @focus="timeEditable"
                    >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8" >
                <el-button type="primary" class="mr10" @click="onSearch(form)">查询</el-button>
                <el-button  @click="resetForm('form')">重置</el-button>
                <el-button @click="onExport" :loading="exportLoading">导出</el-button>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-row>
    </div>
    <Table
      :loading="loading"
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :limit="limit"
      :total="total"
      :offset="offset"
      :emptyText="emptyText"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #dateStr="{ row }">{{ row.dateStr }}</template>
      <template #age1="{ row }">{{ row.age1 ? String(row.age1) :'0'}}</template>
      <template #age2="{ row }">{{ row.age2 ? String(row.age2) :'0'}}</template>
      <template #age3="{ row }">{{ row.age3 ? String(row.age3) :'0'}}</template>
      <template #age4="{ row }">{{ row.age4 ? String(row.age4) :'0'}}</template>
      <template #age5="{ row }">{{ row.age5 ? String(row.age5) :'0'}}</template>
      <template #userCounts="{ row }">{{ String(row.userCounts)? String(row.userCounts) :'0' }}</template>
    </Table>
  </div>
</template>

<script>
import AuthButton from "@/components/AuthButton";
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
import { api_getMemberSaleDataAgeList, api_getMemberSaleDataAgeExport } from "@/api/member";
import { downFile } from "@/utils";
import tableList from "@/mixins/tableList";
export default {
  name: "ageData",
  mixins: [tableList],
  components: {
    AuthButton,
    Search,
    Table
  },
  data() {
    return {
      renderData: [],
      emptyText:'暂无数据',
      form: {
        type:'month',
      },
      pickerOptions: {
                disabledDate(time) {
                  let curDate = new Date().getTime();
                  let three = 186 * 24 * 3600 * 1000;
                  let threeMonths = curDate - three;
                  return (
                    time.getTime() > Date.now() || time.getTime() < threeMonths
                  );
                }
      },
      tableThData: [
        { prop: "dateStr", label: "日期", minWidth: "120" },
        { prop: "age1", label: "0-18岁", minWidth: "120" },
        { prop: "age2", label: "18-30岁", minWidth: "120" },
        { prop: "age3", label: "30-45岁", minWidth: "120" },
        { prop: "age4", label: "45-60岁", minWidth: "120" },
        { prop: "age5", label: "60岁以上", minWidth: "120" },
        { prop: "userCounts", label: "合计", minWidth: "120" },
      ],
      exportLoading: false
    };
  },
  created() {},
  methods: {
    // 点击导出
    async onExport() {
      this.exportLoading = true;
      const params = {
        ...this.form,
      };
    let isGetList = false
    if (params.monthList&&params.monthList.length!=0) {
          isGetList = true 
          params.monthList = params.monthList.map(item=>{
            item = this.$moment(item).format('YYYY-MM')
            console.log(item)
            return item
          })
          if (params.dayList&&params.dayList.length!=0) {
            params.dayList = params.dayList.map(item=>{
            item = this.$moment(item).format('DD') 
             console.log(item)
            return item
          })
          }else{
            let dataList = []
            for (let index = 1; index <= 31; index++) {
              let data = index<10?`0${index}`:String(index)
              dataList.push(data)
            }
            params.dayList = dataList
          }
        }
     if (isGetList) {
      try {
      const res = await api_getMemberSaleDataAgeExport(params);
        downFile(res);
        this.exportLoading = false;
      } catch (error) {
        console.log(error)
        this.exportLoading = false;
      }
     }else{
       this.$baseMessage('请选择需要导出的数据', 'error')
       this.exportLoading = false;
     }
    },
    // 获取表格列表数据
    async getList() {
      this.loading = true;
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit
      };
    let isGetList = false
       if (params.monthList&&params.monthList.length!=0) {
          isGetList = true 
          params.monthList = params.monthList.map(item=>{
            item = this.$moment(item).format('YYYY-MM')
            console.log(item)
            return item
          })
          if (params.dayList&&params.dayList.length!=0) {
            params.dayList = params.dayList.map(item=>{
            item = this.$moment(item).format('DD') 
             console.log(item)
            return item
          })
          }else{
            let dataList = []
            for (let index = 1; index <= 31; index++) {
              let data = index<10?`0${index}`:String(index)
              dataList.push(data)
            }
            params.dayList = dataList
          }
        }
     if (isGetList) {
      try {
      const data = await api_getMemberSaleDataAgeList(params);
      this.tableTrData = data.list || [];
      this.total = data.count;
      this.loading = false;
      data.list.length == 0 ? this.emptyText = '暂无数据':''
      } catch (error) {
        this.loading = false;
        this.emptyText = '暂无数据'
      }
     }else{
      this.tableTrData = [];
      this.total = 0;
      this.loading = false;
      this.emptyText = '请选择需要查询的数据'
     }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.form = {
        type:'month'
      }
    },
    timeEditable() {
      this.$nextTick(() => {
        let els = document.querySelectorAll(
          '.el-date-picker__header'
        )
        for (var i = 0; i <= els.length - 1; i++) {
          els[i].style.display = 'none'
        }
      })
    },
  },
  computed: {},
  watch: {
    form: {
      deep: true,
      handler(newVal, oldVal) {
        this.form = newVal
      }
    }
  }
};
</script>
<style lang="scss" scoped>

.marketing-search{
  // min-height: 186px;
  background-color: #fff;
  border-bottom: 1px solid #cccccc80;
  box-sizing: border-box;
  margin-top: 25px;

  .form-row {
    // height: 64px;
    overflow: hidden;
    display: flex;
    .el-cascader,
    .el-input,
    .el-select,
    .el-input__inner {
      width: 100% !important;
      max-width: 400px;
    }
  }

  .ml80 {
    margin-left: 80px;
  }

  ::v-deep {
    .el-form{
      label{
        font-size: 14px;
      }
      .form-item-row{
        // max-width: calc(100% - 142px);
        display: flex;
        flex-wrap: wrap;
        align-content: space-evenly;
        // justify-content: space-between;
        // min-height: 186px;

        .el-col {
          margin: 10px 0;
          height: 34px;

          &.width0 {
            width: 0;
            padding: 0 !important;
            overflow: hidden;
          }
        }
      }
      .el-form-item{
        margin-bottom: 0;

        .el-form-item__label,
        .el-form-item__content {
          line-height: 34px;

          .el-input__suffix-inner {
            i {
              line-height: 34px;
            }
          }
        }
      }
      .el-select{
        display: block;
      }
      .el-range-editor.el-input__inner{
        width: auto;
        background: #F2F3F5;
        border: 0;
        input{
          background: #F2F3F5;
          border: 0;
        }
      }
      .el-range-editor.el-input__inner.is-active{
        width: auto;
        background: #fff;
        border: 1px solid #05C8AF;
        input{
          background: #fff;
          border: 0;
        }
      }
      .el-input{
        border-radius: 2px;
        font-size: 14px;
        .el-input__inner{
          background: #F2F3F5;
          border: 0;
          height: 34px;
        }
        .el-input__inner:focus{
          background: #fff;
          border: 1px solid #05C8AF;
        }
      }
      .el-input.is-focus+.el-cascader__tags{
        input{
          background: #fff;
        }
      }

      .el-cascader{
        .el-input{
          input{
            height: 34px !important;
          }
        }
      }
      .el-input.is-focus{
        .el-input__inner{
          background: #fff;
          border: 1px solid #05C8AF;
        }
      }
    }
  }

  .form-btn-col {
    display: flex;
    .el-button {
      min-width: 80px !important;
    }
  }
  .button-div{
    height: 34px;
    margin: 10px 0 30px 0;
    overflow: hidden;
    opacity: 1;

    &.height0 {
      height: 0;
      opacity: 0;
      margin: 0;
    }

    .el-button {
      min-width: 80px !important;
    }
  }

  .col-left {
    flex: 1;
  }

  .col-right {
    // width: 300px;
    // background-color: #ccc;
    overflow: hidden;
    height: 34px;
    text-align: right;
    margin: 10px 0;

    .el-button {
      min-width: auto;
      padding: 0 24px;
      margin-right: 0;
      margin-left: 10px;
    }
  }
  .more-btn {
    font-size: 14px;
    padding: 0 !important;
    min-width: auto !important;
    margin-left: 20px !important;

    i {
      margin-left: 10px;
      font-size: 14px;
    }
  }
}
</style>
